export enum RoleToSelect{
    CUSTOMER = 1,
    SUPPLIER = 2
}